import React from "react";
import Cta from "@qlik/qlik/src/components/Cta";
import Media from "@qlik/qlik/src/components/Media";
import { getCardEyebrowText, getCardMedia, renderSanitizedHtmlContent } from "@qlik/qlik/src/lib/util/helpers";
import { getSpacingClassName } from "@qlik/qlik/src/lib/util/spacing";
import { getColorClassName } from "@qlik/qlik/src/lib/util/colors";

const ResourcesSection = ({ data }) => {
    const { additionalConfiguration, backgroundColor, title, cta = [], cardItems = [], customId } = data ?? {};
    const sectionSpacingClassName = getSpacingClassName(additionalConfiguration, "py-15");
    const { sectionColorMapping } = getColorClassName(backgroundColor);

    return (
        <section className={`${sectionSpacingClassName} ${sectionColorMapping.bgColor}`} id={customId}>
            <div className="container">
                <div className="md:flex md:justify-between">
                    {title && (
                        <h2
                            className={`${sectionColorMapping.primaryTextColor} text-center md:text-left md:col-6 lg:col-8`}
                            // eslint-disable-next-line react/no-danger
                            dangerouslySetInnerHTML={{ __html: renderSanitizedHtmlContent(title) }}
                        />
                    )}
                    <div className="flex gap-3.75 flex-wrap justify-center my-5 md:col md:justify-end md:pl-3.75 md:mb-0 md:mt-2.5 items-end">
                        {cta?.[0] && <Cta key={cta[0].id} data={cta[0]} />}
                    </div>
                </div>
                <div className="row mt-10 gap-y-7.25 md:mt-14.5">
                    {cardItems?.map((card) => {
                        const { cta: cardCta, title: cardTitle } = card ?? {};
                        const resourceMedia = getCardMedia(card);
                        const resourceType = getCardEyebrowText(card);
                        return (
                            <div
                                key={card.id}
                                className={`col-12 md:col-6 ${
                                    data?.numberOfColumns
                                        ? `xl:col-${data.numberOfColumns > 0 ? 12 / data.numberOfColumns : "auto"}`
                                        : "xl:col"
                                }`}
                            >
                                <Cta
                                    data={cardCta?.[0]}
                                    className="p-5 w-full h-full after:hidden border border-stone border-opacity-50 rounded group flex flex-col before:hidden hover:no-underline"
                                >
                                    {resourceMedia && (
                                        <div className="contain-paint">
                                            <Media
                                                media={resourceMedia}
                                                className="w-full aspect-ratio-73 md:group-hover:scale-110 transition-transform duration-300"
                                            />
                                        </div>
                                    )}
                                    <div className="mx-2.5 mt-7.75 mb-2.5 h-full flex flex-col justify-between">
                                        <div>
                                            {resourceType && (
                                                <span className="tag-2 uppercase mb-2.5 block md:mb-4.75">
                                                    {resourceType}
                                                </span>
                                            )}
                                            {cardTitle && (
                                                <h3 className="title-5 line-clamp-3 text-gray">{cardTitle}</h3>
                                            )}
                                        </div>
                                        {cardCta?.[0]?.text && (
                                            <span className="green-link md:group-hover:after:translate-x-0.75 md:group-hover:text-dark-green md:group-hover:after:arrow-green-dark mt-7.25">
                                                {cardCta[0].text}
                                            </span>
                                        )}
                                    </div>
                                </Cta>
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
};

export default ResourcesSection;
